import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/layouts/Layout";

const CompanyInfoPage = () => {
  const { section } = useParams();
  const [activeTab, setActiveTab] = useState(section || 'overview');

  const managementTeam = [
    {
      id: 1,
      name: "谷前 太喜",
      position: "代表取締役CEO",
      bio: "東京理科大学先進工学部大学院生として量子物理学やカーボンナノチューブ（CNT）、およびPRC（物理リザバコンピュータ）の研究を行う。AI業界歴3年、AIベンチャー企業の取締役として大手企業から中小企業まで幅広いクライアントにAIコンサルティングを提供。ChatGPTを活用した教育プログラムで30名以上の受講者に個別指導を実施。",
      expertise: ["量子物理学", "カーボンナノチューブ", "リザバコンピュータ", "AIコンサルティング"],
      education: "東京理科大学先進工学部大学院",
      experience: "AI業界歴3年、AIベンチャー企業取締役経験",
      image: "Executive",
      linkedin: "#",
      twitter: "#"
    },
    {
      id: 2,
      name: "杉本 迅",
      position: "取締役COO",
      bio: "IT・AI業界合わせ4年の経験を持つデータサイエンティスト。生成AI・機械学習・量子コンピュータなどのソフトウェア開発及び技術顧問として中小企業から大手まで60社以上をサポート。専門は、QNN（量子ニューラルネットワーク）。技術コンペ表彰1位、起業家ピッチイベント技術賞受賞。",
      expertise: ["量子ニューラルネットワーク", "データサイエンス", "機械学習", "プロジェクトマネジメント"],
      education: "—",
      experience: "IT・AI業界4年、60社以上サポート実績",
      image: "Executive",
      linkedin: "#",
      twitter: "#"
    },
    {
      id: 3,
      name: "丹治 光太郎",
      position: "CTO",
      bio: "2025年2月1日就任。アニマルサイエンス分野の専門知識を持ち、Laravel系開発、Node.js系開発、Vue.jsを得意とする技術リーダー。",
      expertise: ["アニマルサイエンス", "Laravel", "Node.js", "Vue.js"],
      education: "—",
      experience: "フルスタック開発、技術リーダーシップ",
      image: "Executive",
      linkedin: "#",
      twitter: "#"
    }
  ];

  const rdDivisions = [
    {
      id: 1,
      name: "量子リザバコンピューティング研究",
      description: "QRC技術の研究開発と実用化",
      head: "谷前太喜（CEO）・杉本迅（COO）",
      members: 5,
      projects: ["時系列予測システム", "異常検知アルゴリズム", "量子アニーリング最適化"],
      achievements: ["特許出願15+件", "査読論文8件", "総引用数400+件"],
    },
    {
      id: 2,
      name: "AI・機械学習応用研究",
      description: "産業応用に特化したAI技術開発",
      head: "杉本迅（COO）",
      members: 3,
      projects: ["カスタムSLM「Hamster」", "生成AI建築BIM", "農業プラットフォーム"],
      achievements: ["60社以上導入実績", "複数受賞歴", "DeepLabリピーター千人以上"],
    },
    {
      id: 3,
      name: "プラットフォーム開発",
      description: "つなぎスマイル、CorPiaなどのプラットフォーム開発",
      head: "丹治光太郎（CTO）",
      members: 2,
      projects: ["つなぎスマイル", "CorPia", "チャットボットシステム"],
      achievements: ["複数プラットフォーム運用", "フルスタック開発体制", "スケーラブル設計"],
    }
  ];

  const companyData = {
    name: "株式会社DeepTeLL",
    established: "2024年（令和6年）10月1日",
    capital: "10万円（2025年1月11日現在）",
    employees: "個別：5名、連結：41社（2025年1月11日現在）",
    headquarters: "〒112-0012 東京都台東区蔵前1-3-28",
    phone: "TEL：070-1734-7502",
    website: "https://deeptell.co.jp/",
    business: [
      "AI・機械学習技術の研究開発",
      "量子コンピューティング関連技術開発",
      "AIコンサルティングサービス",
      "受託開発・システム開発",
      "農業プラットフォーム事業"
    ],
    mission: "AIを日常に",
    vision: "日本のAIリテラシーを底上げ。経済のスピードアップを目指す。",
    values: [
      "営業しない：関係構築を最優先に",
      "具体的である：実績や事例を提示",
      "顧客の成功に寄り添う：顧客の成功を最優先に"
    ],
    milestones: [
      "2024年6月：発足（ディープテックのDeepと教育の伝える意味を込めて、DeepTeLL命名）",
      "2024年10月：法人登記（AI技術顧問、開発会社として）",
      "2024年10月：谷前太喜 代表取締役CEO就任",
      "2024年10月：杉本迅 取締役COO就任",
      "2025年2月：丹治光太郎 CTO就任"
    ]
  };

  return (
    <Layout 
      title="企業情報" 
      subtitle="DeepTeLLの会社概要、経営陣、研究開発体制についてご紹介します"
    >
      {/* タブナビゲーション */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'inline-flex', background: 'rgba(30, 41, 59, 0.8)', borderRadius: '8px', padding: '4px' }}>
                  <button
                    className={`btn ${activeTab === 'overview' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('overview')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'overview' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'overview' ? 'white' : '#cbd5e1'
                    }}
                  >
                    会社概要
                  </button>
                  <button
                    className={`btn ${activeTab === 'management' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('management')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'management' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'management' ? 'white' : '#cbd5e1'
                    }}
                  >
                    経営陣紹介
                  </button>
                  <button
                    className={`btn ${activeTab === 'rd' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('rd')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'rd' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'rd' ? 'white' : '#cbd5e1'
                    }}
                  >
                    研究開発体制
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 会社概要 */}
      {activeTab === 'overview' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="premium-card" style={{ 
                  padding: '40px',
                  marginBottom: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h3 style={{ color: '#3b82f6', marginBottom: '25px' }}>会社概要</h3>
                  
                  <div className="row" style={{ marginBottom: '30px' }}>
                    <div className="col-md-4">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>会社名</h5>
                      <p style={{ color: '#cbd5e1' }}>{companyData.name}</p>
                    </div>
                    <div className="col-md-4">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>設立</h5>
                      <p style={{ color: '#cbd5e1' }}>{companyData.established}</p>
                    </div>
                  </div>

                  <div className="row" style={{ marginBottom: '30px' }}>
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>従業員数</h5>
                      <p style={{ color: '#cbd5e1' }}>{companyData.employees}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>本社所在地</h5>
                      <p style={{ color: '#cbd5e1' }}>{companyData.headquarters}</p>
                    </div>
                  </div>

                  <div className="row" style={{ marginBottom: '30px' }}>
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>電話番号</h5>
                      <p style={{ color: '#cbd5e1' }}>{companyData.phone}</p>
                    </div>
                    <div className="col-md-6">
                      <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>ウェブサイト</h5>
                      <p style={{ color: '#cbd5e1' }}>
                        <a href={companyData.website} style={{ color: '#3b82f6' }}>
                          {companyData.website}
                        </a>
                      </p>
                    </div>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h5 style={{ color: '#f1f5f9', marginBottom: '15px' }}>事業内容</h5>
                    <ul style={{ color: '#cbd5e1', marginLeft: '20px' }}>
                      {companyData.business.map((item, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {item}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* MVV */}
                <div className="premium-card" style={{ 
                  padding: '40px',
                  marginBottom: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h3 style={{ color: '#3b82f6', marginBottom: '25px' }}>🎯 ミッション・ビジョン・バリュー</h3>
                  
                  <div style={{ marginBottom: '25px' }}>
                    <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>🎯 ミッション</h5>
                    <p style={{ color: '#cbd5e1', fontSize: '18px', fontWeight: '600' }}>{companyData.mission}</p>
                    <p style={{ color: '#94a3b8', fontSize: '14px' }}>
                      私たちは、AI技術を一般の人々や企業の日常生活に溶け込ませ、AIが特別な技術ではなく、誰もが使いこなせるツールとなることを目指します。
                    </p>
                  </div>
                  
                  <div style={{ marginBottom: '25px' }}>
                    <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>🔮 ビジョン</h5>
                    <p style={{ color: '#cbd5e1', fontSize: '16px', fontWeight: '600' }}>{companyData.vision}</p>
                    <p style={{ color: '#94a3b8', fontSize: '14px' }}>
                      私たちの目標は、日本人のAIリテラシーを向上させ、生産性をアップさせる方法を提供することです。AIが手助けし、業務時間を軽減させ、人材を新しい事業などに当てるようになってほしいです。
                    </p>
                  </div>
                  
                  <div>
                    <h5 style={{ color: '#f1f5f9', marginBottom: '15px' }}>⚖️ バリュー</h5>
                    <ul style={{ color: '#cbd5e1', marginLeft: '20px' }}>
                      {companyData.values.map((value, index) => (
                        <li key={index} style={{ marginBottom: '8px' }}>• {value}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                {/* 沿革 */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  marginBottom: '20px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>沿革</h4>
                  <ul style={{ color: '#cbd5e1', listStyle: 'none', marginLeft: 0 }}>
                    {companyData.milestones.map((milestone, index) => (
                      <li key={index} style={{ marginBottom: '15px', fontSize: '14px' }}>
                        <div style={{ color: '#3b82f6', fontWeight: '600', marginBottom: '5px' }}>
                          {milestone.split('：')[0]}
                        </div>
                        <div style={{ paddingLeft: '10px' }}>
                          {milestone.split('：')[1]}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* オフィス所在地 */}
      <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
        {/* 上記と同じ内容 */}
      </section>

      {/* 経営陣紹介 */}
      {activeTab === 'management' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              {managementTeam.map((member) => (
                <div key={member.id} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div className="premium-card" style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '80px', marginBottom: '20px' }}>{member.image}</div>
                    <h3 style={{ color: '#3b82f6', marginBottom: '10px' }}>{member.name}</h3>
                    <h5 style={{ color: '#f59e0b', marginBottom: '20px' }}>{member.position}</h5>
                    
                    <p style={{ color: '#cbd5e1', marginBottom: '20px', textAlign: 'left', fontSize: '14px' }}>
                      {member.bio}
                    </p>

                    {/* 教育・経験情報 */}
                    <div style={{ marginBottom: '20px', textAlign: 'left' }}>
                      <div style={{ marginBottom: '10px' }}>
                        <h6 style={{ color: '#f1f5f9', fontSize: '12px', marginBottom: '5px' }}>学歴</h6>
                        <p style={{ color: '#94a3b8', fontSize: '12px' }}>{member.education}</p>
                      </div>
                      <div>
                        <h6 style={{ color: '#f1f5f9', fontSize: '12px', marginBottom: '5px' }}>経験</h6>
                        <p style={{ color: '#94a3b8', fontSize: '12px' }}>{member.experience}</p>
                      </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h6 style={{ color: '#f1f5f9', marginBottom: '10px' }}>専門分野</h6>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                        {member.expertise.map((skill, index) => (
                          <span key={index} style={{ 
                            background: 'rgba(16, 185, 129, 0.2)',
                            color: '#10b981',
                            padding: '4px 8px',
                            borderRadius: '12px',
                            fontSize: '12px'
                          }}>
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                      <a href={member.linkedin} style={{ color: '#3b82f6', fontSize: '24px' }}>📱</a>
                      <a href={member.twitter} style={{ color: '#3b82f6', fontSize: '24px' }}>🐦</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 研究開発体制 */}
      {activeTab === 'rd' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '20px' }}>🔬 研究開発体制</h2>
                  <p style={{ color: '#cbd5e1', fontSize: '18px' }}>
                    世界最高水準の研究開発力で、次世代AI技術の創造に挑戦します
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              {rdDivisions.map((division) => (
                <div key={division.id} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div style={{ 
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    padding: '30px'
                  }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>{division.name}</h4>
                    <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                      {division.description}
                    </p>

                    <div style={{ marginBottom: '15px' }}>
                      <div style={{ color: '#cbd5e1', fontSize: '14px', marginBottom: '5px' }}>
                        <strong>責任者:</strong> {division.head}
                      </div>
                      <div style={{ color: '#cbd5e1', fontSize: '14px' }}>
                        <strong>メンバー:</strong> {division.members}名
                      </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <h6 style={{ color: '#3b82f6', marginBottom: '10px' }}>主要プロジェクト</h6>
                      <ul style={{ color: '#cbd5e1', fontSize: '13px', paddingLeft: '15px' }}>
                        {division.projects.map((project, index) => (
                          <li key={index} style={{ marginBottom: '3px' }}>{project}</li>
                        ))}
                      </ul>
                    </div>

                    <div>
                      <h6 style={{ color: '#3b82f6', marginBottom: '10px' }}>主な成果</h6>
                      <ul style={{ color: '#cbd5e1', fontSize: '13px', paddingLeft: '15px' }}>
                        {division.achievements.map((achievement, index) => (
                          <li key={index} style={{ marginBottom: '3px' }}>{achievement}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA セクション */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                私たちと一緒に働きませんか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                世界を変えるAI技術の開発に参加し、あなたの技術力を最大限に発揮しませんか。
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="/careers" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                                          採用情報を見る
                </a>
                <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                                      お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CompanyInfoPage; 